import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { scale170, spaceS } from '@xing-com/tokens';

export const ProfileImageMeMenuContainer = styled.div`
  position: relative;
  padding: ${spaceS};
`;

export const ProfileImageWrapper = styled(Button)`
  padding: 0;
  align-items: center;
  display: flex;
  height: ${scale170};
  justify-content: center;
`;
